import { cva } from 'class-variance-authority'

/*
 * Ported from `.button` and its modifiers in the Webflow stylesheet.
 *
 *   .button                  border + bg var(--font-default), radius 200px, 16/32
 *   .button.button-primary   border + bg var(--blue), hover var(--blue-700)
 *   .button.button-outline   transparent, blue border + text, weight 600
 *   .button.small            font-size var(--small-text-size), padding 12/16
 *   .button.button-*.small   padding 12/20
 *
 * White text comes from Webflow's own `.w-button` base, not from `.button`.
 *
 * Kept in its own module so the component file exports only components —
 * otherwise React Fast Refresh cannot hot-reload it.
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-pill border border-solid text-center font-heading leading-[1em] tracking-normal no-underline transition-all duration-200 focus-ring',
  {
    variants: {
      variant: {
        default: 'border-font-default bg-font-default font-medium text-white',
        primary: 'border-blue bg-blue font-medium text-white hover:bg-blue-700',
        outline:
          'border-blue bg-transparent font-semibold text-blue hover:border-blue-700 hover:bg-blue-700 hover:text-white',
        outlineWhite:
          'border-white bg-transparent font-semibold text-white hover:border-blue-700 hover:bg-blue-700',
        link: 'rounded-none border-none bg-transparent p-0 text-blue',
      },
      size: {
        default: 'px-8 py-4 text-base',
        small: 'px-4 py-3 text-small',
      },
      fullWidth: { true: 'w-full' },
    },
    compoundVariants: [
      // `.button.button-primary.small` and `.button.button-outline.small`
      // override `.button.small`'s padding.
      { variant: 'primary', size: 'small', class: 'flex-none px-5 py-3' },
      { variant: 'outline', size: 'small', class: 'px-5 py-3' },
      { variant: 'outlineWhite', size: 'small', class: 'px-5 py-3' },
    ],
    defaultVariants: { variant: 'default', size: 'default' },
  },
)
